// @ts-strict-ignore
import React from 'react'
import clsx from 'clsx'
import {
  Box,
  CopyButton,
  Box as LeftContainer,
  Box as RightContainer,
  Box as TableCell,
  Box as TableRow,
} from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'

interface DataListItemCustomProps {
  id: string | number
  title: string
  textList?: string[]
  testId?: string
}

export const DataListItemCustom = ({ id, title, textList, testId }: DataListItemCustomProps) => {
  const bodyTextClasses = clsx(
    'text-left text-foreground-prominent self-center break-all text-right text-body-strong'
  )

  const isSingleItem = textList?.length === 1

  const renderTextItems = () => {
    return textList?.map(text => (
      <Box
        key={text}
        flex
        justify="between"
        align="center"
        gapX={4}
        className="last:odd:col-start-2"
      >
        <Box flex gapX={4}>
          <span className={bodyTextClasses}>
            {isSingleItem ? ellipseMiddleText(text, 15, 10) : ellipseMiddleText(text, 6, 6)}
          </span>
        </Box>
        <Box align="center" flex gapX={4}>
          {text && <CopyButton copyText={text} />}
        </Box>
      </Box>
    ))
  }

  return (
    <TableRow key={id} data-testid={testId} className="w-full flex justify-between py-2 min-h-10">
      <TableCell className="p-0">
        <LeftContainer gap={4} className="items-start">
          <span className="text-foreground-subdued text-body-regular">{title}</span>
        </LeftContainer>
      </TableCell>
      <TableCell flex align="center" justify="center" className="p-0">
        <RightContainer {...(!isSingleItem ? { className: 'grid grid-cols-2 gap-2' } : {})}>
          {renderTextItems()}
        </RightContainer>
      </TableCell>
    </TableRow>
  )
}
